<script setup lang="ts">
import { usePageLoaded } from '../composables/usePageLoaded'

defineProps<{
  eyebrow?: string
  title: string
  inverse?: boolean
  watermark?: string
}>()

// 水印图等页面 load 之后再加载（原因见 usePageLoaded）
const pageLoaded = usePageLoaded()
</script>

<template>
  <div
    class="section-title"
    :class="{
      'section-title--inverse': inverse,
      'section-title--watermark': watermark,
    }"
  >
    <span v-if="watermark && pageLoaded" class="section-title__watermark" aria-hidden="true">
      <img class="section-title__watermark-art" :src="watermark" alt="" decoding="async" />
      <!-- 用同一张图作遮罩，把高光限制在笔画内部 -->
      <span
        class="section-title__watermark-shine"
        :style="{
          '-webkit-mask-image': `url(${watermark})`,
          maskImage: `url(${watermark})`,
        }"
      ></span>
    </span>
    <span v-if="eyebrow" class="section-title__eyebrow">{{ eyebrow }}</span>
    <h2><span aria-hidden="true">“</span>{{ title }}<span aria-hidden="true">”</span></h2>
    <span v-if="!watermark" class="section-title__scribble" aria-hidden="true">Rarecard</span>
  </div>
</template>
